import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import classes from "./Toolbar.module.css";
import mine from "../../assets/imgs/mineS.jpg";
import { useSelector } from "react-redux";

const Toolbar = (props) => {
	const [show, setShow] = useState(false);
	const [scrolling, setScrolling] = useState(false);

	const pushHeight = () => {
		setShow(!show);
	};

	window.onscroll = () => {
		if (
			document.body.scrollTop > 50 ||
			document.documentElement.scrollTop > 50
		) {
			setScrolling(true);
		} else if (
			document.body.scrollTop < 50 ||
			document.documentElement.scrollTop < 50
		) {
			setScrolling(false);
		}
	};

	const token = useSelector((state) => state.auth.token);
	// console.log(show);
	return (
		<div className={[classes.Toolbar].join(" ")}>
			<div className={classes.NameHeader}>
				<img src={mine} alt='Sheikh Muzammil Ahmed' />
				<span className={classes.NameDesig}>
					<span style={{ fontSize: "18px" }}>Sheikh Muzammil Ahmed</span>
					<span style={{ fontSize: "13px" }}>MERN Stack Developer</span>
				</span>
			</div>
			<div onClick={() => pushHeight()} className={classes.Burger}>
				<div className={[show && classes.topDiv, classes.Line].join(" ")}></div>
				<div
					className={[show && classes.middleDiv, classes.Line].join(" ")}></div>
				<div
					className={[show && classes.bottomDiv, classes.Line].join(" ")}></div>
			</div>
			<nav>
				<ul
					className={[
						show ? classes.Height : null,
						scrolling ? classes.Scrolling : null,
					].join(" ")}>
					<li onClick={() => pushHeight()}>
						<NavLink
							className={scrolling ? classes.Scrolling : null}
							activeClassName={classes.active}
							to='/'
							exact>
							Home
						</NavLink>
					</li>
					<li onClick={() => pushHeight()}>
						<NavLink
							className={scrolling ? classes.Scrolling : null}
							activeClassName={classes.active}
							to='/certificates'
							exact>
							Certifications
						</NavLink>
					</li>
					<li onClick={() => pushHeight()}>
						<NavLink
							className={scrolling ? classes.Scrolling : null}
							activeClassName={classes.active}
							to='/resume'>
							Resume
						</NavLink>
					</li>
					<li onClick={() => pushHeight()}>
						<NavLink
							className={scrolling ? classes.Scrolling : null}
							activeClassName={classes.active}
							to='/contact'>
							Contact
						</NavLink>
					</li>
					<li onClick={() => pushHeight()}>
						<NavLink
							className={[
								classes.Button,
								scrolling ? classes.Scrolling : null,
							].join(" ")}
							activeClassName={classes.active}
							to='/hire-me'>
							Hire Me!
						</NavLink>
					</li>
					{token && (
						<React.Fragment>
							<li onClick={() => pushHeight()}>
								<NavLink
									className={scrolling ? classes.Scrolling : null}
									activeClassName={classes.active}
									to='/messages'>
									Messages
								</NavLink>
							</li>
							<li onClick={() => pushHeight()}>
								<NavLink
									className={scrolling ? classes.Scrolling : null}
									activeClassName={classes.active}
									to='/logout'>
									Logout
								</NavLink>
							</li>
						</React.Fragment>
					)}
				</ul>
			</nav>
		</div>
	);
};

export default Toolbar;
